enum FROM_AMOUNT_PERCENT {
  ALL = "ALL",
  HALF = "HALF",
  MIN = "MIN",
}

export default FROM_AMOUNT_PERCENT;
